// eslint-disable-next-line import/no-cycle
import store from '@client/store';
import {Route, NavigationGuardNext} from 'vue-router';
import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum GoalRouteNames {
  GoalsPage = 'GoalsPage',
  GoalDetailsPage = 'GoalDetailsPage',
  AddGoalPage = 'AddGoal',
  GoalAllocationPage = 'GoalAllocationPage',
}

export default [
  {
    path: '/clientdashboard/goals',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    name: GoalRouteNames.GoalsPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/goals/GoalsPage.vue'),
  },
  {
    path: '/clientdashboard/goals/:id',
    name: GoalRouteNames.GoalDetailsPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/goals/GoalDetailsPage.vue'),
    props: true,
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      await store.dispatch('goal/getGoalSelection');
      await store.dispatch('risk/fetchRtqData');
      next();
    },
  },
  {
    path: '/clientdashboard/add-goal',
    // TODO: Change to AddGoalPage after CMS is refactored
    name: GoalRouteNames.AddGoalPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/goals/AddGoalPage.vue'),
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      await store.dispatch('goal/getGoalSelection');
      await store.dispatch('user/get');
      next();
    },
  },
  {
    path: '/clientdashboard/goal-allocation',
    name: GoalRouteNames.GoalAllocationPage,
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/pages/goals/GoalAllocationPage.vue'),
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // Go back to the AddGoal page on refresh since we'll lose state
      if (store.state.goal.toAdd) {
        await store.dispatch('goal/getAllocation', _to.params.portfolioType);
        // eslint-disable-next-line callback-return
        next();
      } else {
        // eslint-disable-next-line callback-return
        next({name: GoalRouteNames.AddGoalPage});
      }
    },
  },
];
